<template>
  <q-btn
    v-if="isGranted('VIEW_POST_NOTES')"
    icon="fa fa-comment-dots"
    :title="title"
    v-bind="$attrs"
    @click="openModal"
  >
    <q-badge
      v-show="post.totalNotes"
      :label="post.totalNotes"
      color="primary"
      outline
      floating
      style="top: -1px"
    />
  </q-btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';
import isGranted from '@/auth/isGranted';
import openModal from '@/components/modal';
import PostNotesModal from './PostNotesModal.vue';

export default defineComponent({
  props: {
    post: {
      type: Object as () => Post,
      required: true,
    },
    title: {
      type: String,
      default: 'Notes',
    },
  },
  methods: {
    isGranted,
    openModal() {
      const config = { parent: this, post: this.post };
      openModal(PostNotesModal, config);
    },
  },
});
</script>
